import { useMemo } from 'react'
import { Accordion, Title, Body, AccordionPanel } from '@panwds/react-ui'
import { PanWLogoWithText } from '../../assets'
import { DO_NOT_DISPLAY_ADDONS } from '../common/GlobalConstants'

import type { CommonStoreState } from '../../store'
import DefaultPrimaryLicenseDetails from '../DefaultPrimaryLicenseDetails'

export interface UScreenHeaderProps {
  state: CommonStoreState;
  title: string;
  headerAppId?: string;
  hideLicenseInfo?: boolean
  showAppTitle?: boolean
  showDeviceLicense?: boolean
}
const UScreenHeader = (props: UScreenHeaderProps) => {
  const { state, title, headerAppId, hideLicenseInfo, showAppTitle, showDeviceLicense } = props
  const { apps } = state
  const headerLicenses = useMemo(() => {
    return state?.licenses?.find(each => each.app_id === headerAppId)?.licenses.filter(each => !DO_NOT_DISPLAY_ADDONS.has(each.app_id as string))
  }, [state, headerAppId])

  return (
    <div className='cm-fixed cm-top-0 cm-left-0 cm-w-full cm-px-20 cm-z-40 cm-flex cm-justify-center'>
      <div className='cm-w-[1000px]'>
        <div className='cm-bg-white dark:cm-bg-gray-1050 cm-pt-10'>
          <img className='cm-w-[132px]' alt={'logo'} src={PanWLogoWithText} />
          <Title addClassName='cm-flex' level={1} size={'sm'}>
            {title}
          </Title>
        </div>
        {!hideLicenseInfo && (<Accordion
          allowNoneOpen
          defaultOpenPanels={[]}
        >
          <AccordionPanel title={apps.get(headerAppId || '')?.display_name} addClassName='cm-border-none' indicator={true}>
            {!showDeviceLicense && headerLicenses?.map(({ license_display_name, purchased_size, purchased_unit }, index) => {
              return (<Body key={index}>{license_display_name}: {purchased_size} {purchased_unit} </Body>)
            })}
            {showDeviceLicense && <DefaultPrimaryLicenseDetails state={state}></DefaultPrimaryLicenseDetails>}
          </AccordionPanel>
        </Accordion>)}
        {showAppTitle && <Body as="div" className="tw-mb-0 tw-px-6 tw-py-1.5 tw-text-base tw-font-semibold cm-bg-white dark:cm-bg-gray-1050">
          {apps.get(headerAppId || '')?.display_name}
        </Body>}
        <div className='cm-w-[1000px] cm-h-5 cm-bg-gradient-to-b cm-from-white cm-to-transparent dark:cm-from-gray-1050'></div>
      </div>
    </div>
  )
}

export default UScreenHeader
